export const CDR_PER_PAGE = "CDR_PER_PAGE";
export const MDR_FAILED_PER_PAGE = "MDR_FAILED_PER_PAGE";
export const FULL_REPORT_PER_PAGE = "FULL_REPORT_PER_PAGE";

export const LOCAL_STORAGE_USER_INFO = "userInfo";

export const LOCAL_STORAGE_DELAYED_SERVICE_CHANGE = "LOCAL_STORAGE_DELAYED_SERVICE_CHANGE";

export const LOCAL_STORAGE_TRAFFIC_STAT_FILTERS = "payments/LOCAL_STORAGE_TRAFFIC_STAT_FILTERS";
export const LOCAL_STORAGE_PAYMENTS_TRAFFIC_REPORTS_FILTERS = "payments/LOCAL_STORAGE_PAYMENTS_TRAFFIC_REPORTS_FILTERS";
export const LOCAL_STORAGE_PAYMENTS_LIST_FILTERS = "payments/LOCAL_STORAGE_PAYMENTS_LIST_FILTERS";

export const LOCAL_STORAGE_SIM_TRAFFIC_RANGES_FILTERS = "LOCAL_STORAGE_SIM_TRAFFIC_RANGES_FILTERS";
export const LOCAL_STORAGE_LIVE_CALLS_AUTO_UPDATE = "LOCAL_STORAGE_LIVE_CALLS_AUTO_UPDATE";

export const LOCAL_STORAGE_CHECKED_PAYMENT_STATUS = "LOCAL_STORAGE_CHECKED_PAYMENT_STATUS";

export const LOCAL_STORAGE_SUBACC_LIVE_CALLS_AUTO_UPDATE = "LOCAL_STORAGE_SUBACC_LIVE_CALLS_AUTO_UPDATE";

export const LS_LAST_VISITED = "LS_LAST_VISITED";
export const LS_LAST_PAGE = "LS_LAST_PAGE";
export const LS_LAST_SERVICE = "LS_LAST_SERVICE";
export const LS_SESSION_EXPIRED = "LS_SESSION_EXPIRED";

export const LS_ACCESS_LIST_PER_PAGE = "LS_ACCESS_LIST_PER_PAGE";
export const LS_CDR_PER_PAGE = "LS_CDR_PER_PAGE";
export const LS_FAILED_MDR_PER_PAGE = "LS_FAILED_MDR_PER_PAGE";
export const LS_E164_PER_PAGE = "LS_E164_PER_PAGE";
export const LS_E212_PER_PAGE = "LS_E212_PER_PAGE";
export const LS_FULL_REPORT_PER_PAGE = "LS_FULL_REPORT_PER_PAGE";
export const LS_MANUAL_ACCESS_LIST_PER_PAGE = "LS_MANUAL_ACCESS_LIST_PER_PAGE";
export const LS_RANGES_AND_NUMBERS_RANGES_PER_PAGE = "LS_RANGES_AND_NUMBERS_RANGES_PER_PAGE";
export const LS_RANGES_AND_NUMBERS_NUMBERS_PER_PAGE = "LS_RANGES_AND_NUMBERS_NUMBERS_PER_PAGE";
export const LS_TRAFFIC_REPORTS_PER_PAGE = "LS_TRAFFIC_REPORTS_PER_PAGE";
export const LS_ACTION_LOGS_PER_PAGE = "LS_ACTION_LOGS_PER_PAGE";
export const LS_FAKE_DLR_PER_PAGE = "LS_FAKE_DLR_PER_PAGE";
export const LS_GLOBAL_ACCESS_NUMBERS_PER_PAGE = "LS_GLOBAL_ACCESS_NUMBERS_PER_PAGE";
export const LS_ACCOUNT_RATES_PER_PAGE = "LS_ACCOUNT_RATES_PER_PAGE";
export const LS_ACCOUNT_ALLOCATED_NUMBERS_PER_PAGE = "LS_ACCOUNT_ALLOCATED_NUMBERS_PER_PAGE";
export const LS_ACCOUNT_ALLOCATED_NUMBERS_GAN_PER_PAGE = "LS_ACCOUNT_ALLOCATED_NUMBERS_GAN_PER_PAGE";
export const LS_ACCOUNT_ALLOCATED_NUMBERS_TRANSIT_PER_PAGE = "LS_ACCOUNT_ALLOCATED_NUMBERS_TRANSIT_PER_PAGE";
export const LS_DIALER_GLOBAL_ACCESS_NUMBERS_PER_PAGE = "LS_DIALER_GLOBAL_ACCESS_NUMBERS_PER_PAGE";
export const LS_DIALER_CDR_PER_PAGE = "LS_DIALER_CDR_PER_PAGE";
export const LS_DIALER_CDR_VOICE_PER_PAGE = "LS_DIALER_CDR_VOICE_PER_PAGE";
export const LS_DIALER_CDR_SMS_PER_PAGE = "LS_DIALER_CDR_SMS_PER_PAGE";
export const LS_DIALER_TRAFFIC_STAT_PER_PAGE = "LS_DIALER_TRAFFIC_STAT_PER_PAGE";
export const LS_DIALER_TRAFFIC_STAT_VOICE_PER_PAGE = "LS_DIALER_TRAFFIC_STAT_VOICE_PER_PAGE";
export const LS_DIALER_TRAFFIC_STAT_SMS_PER_PAGE = "LS_DIALER_TRAFFIC_STAT_SMS_PER_PAGE";
export const LS_DIALER_ACCESS_LIST_FILTERS_PER_PAGE = "LS_DIALER_ACCESS_LIST_FILTERS_PER_PAGE";
export const LS_DIALER_AUTH_NUMBERS_PER_PAGE = "LS_DIALER_AUTH_NUMBERS_PER_PAGE";
export const LS_DIALER_PRICE_PER_PAGE = "LS_DIALER_PRICE_PER_PAGE";
export const LS_DIALER_ACCESSES_PER_PAGE = "LS_DIALER_ACCESSES_PER_PAGE";
export const LS_DIALER_GLOBAL_ACCESSES_PER_PAGE = "LS_DIALER_GLOBAL_ACCESSES_PER_PAGE";
export const LS_DIALER_HOT_ACCESSES_PER_PAGE = "LS_DIALER_HOT_ACCESSES_PER_PAGE";
export const LS_DIALER_NUMBERS_PER_PAGE = "LS_DIALER_NUMBERS_PER_PAGE";
export const LS_DIALER_LIVE_CALLS_PER_PAGE = "LS_DIALER_LIVE_CALLS_PER_PAGE";
export const LS_DIALER_TEST_CALLS_PER_PAGE = "LS_DIALER_TEST_CALLS_PER_PAGE";
export const LS_DIALER_SUBACCOUNT_ACCESS_LIST_PER_PAGE = "LS_DIALER_SUBACCOUNT_ACCESS_LIST_PER_PAGE";
export const LS_DIALER_SUBACCOUNT_NUMBERS_PER_PAGE = "LS_DIALER_SUBACCOUNT_NUMBERS_PER_PAGE";
export const LS_DIALER_SUBACCOUNT_TRAFFIC_PER_PAGE = "LS_DIALER_SUBACCOUNT_TRAFFIC_PER_PAGE";
export const LS_DIALER_SUBACCOUNT_LIVE_CALLS_PER_PAGE = "LS_DIALER_SUBACCOUNT_LIVE_CALLS_PER_PAGE";
export const LS_DIALER_SUBACCOUNT_ACCOUNT_NUMBERS_PER_PAGE = "LS_DIALER_SUBACCOUNT_ACCOUNT_NUMBERS_PER_PAGE";

export const LS_ACCOUNTS_COLUMNS = "LS_ACCOUNTS_COLUMNS";
export const LS_DIALERS_COLUMNS = "LS_DIALERS_COLUMNS";
export const LS_CDR_COLUMNS = "LS_CDR_COLUMNS";
export const LS_CDR_FAILED_COLUMNS = "LS_CDR_FAILED_COLUMNS";
export const LS_CDR_SMS_COLUMNS = "LS_CDR_SMS_COLUMNS";
export const LS_LIVE_CALLS_COLUMNS = "LS_LIVE_CALLS_COLUMNS";

export const LS_DIALER_CDR_COLUMNS = "LS_DIALER_CDR_COLUMNS";
export const LS_DIALER_CDR_FILTERS = "LS_DIALER_CDR_FILTERS";
export const LS_DIALER_LIVE_CALLS_COLUMNS = "LS_DIALER_LIVE_CALLS_COLUMNS";
export const LS_DIALER_TRAFFIC_STAT_COLUMNS = "LS_DIALER_TRAFFIC_STAT_COLUMNS";

export const LS_ALLOCATED_NUMBERS_COLUMNS_PREFIX = "allocatedNumbers_";
